import { Outlet, useLoaderData, useSubmit } from 'react-router-dom';
import { Container } from '@dma/ui';
import type { AdminSession } from '../domain/entities/AdminSession.entity';
import { useDocumentHead } from '../../../app/seo/useDocumentHead';
import { staticSeo } from '../../../app/seo/static-seo.content';
import './AdminLayout.css';

/**
 * Parent route element for every `/admin/*` page. Its loader (see
 * features/admin/routes.tsx) both supplies the session data consumed here
 * AND enforces the guard (redirecting to /admin/login when there is none) —
 * this component can therefore assume `session` is always present.
 *
 * Applies `noIndex` here rather than on each individual admin page: since
 * every /admin/* route renders inside this shell, one `useDocumentHead` call
 * keeps the whole panel out of search results without repeating the same
 * call on the dashboard, mineralogy admin, petrology admin, etc.
 */
export function AdminLayout() {
  const session = useLoaderData() as AdminSession;
  const submit = useSubmit();
  useDocumentHead(staticSeo.adminGeneric, { noIndex: true });

  function handleLogout() {
    submit(null, { method: 'post', action: '/admin/logout' });
  }

  return (
    <div className="dma-admin-layout">
      <header className="dma-admin-layout__header">
        <Container>
          <div className="dma-admin-layout__header-inner">
            <span className="dma-admin-layout__brand">پنل مدیریت — داریوش معدن آذر</span>
            <div className="dma-admin-layout__user">
              <span className="dma-admin-layout__email">{session.email}</span>
              <button type="button" className="dma-admin-layout__logout" onClick={handleLogout}>
                خروج
              </button>
            </div>
          </div>
        </Container>
      </header>
      <main className="dma-admin-layout__content">
        <Container>
          <Outlet />
        </Container>
      </main>
    </div>
  );
}
